import React, { useRef, useEffect, useState } from "react";
import DeleteConfirmatiom from "../General/DeleteConfirmation";
import { enumUtil } from "../../utils/Enum";
import useHandleOpenNewBrowserTab from "../shared/NewTabBrowser/useHandleOpenNewBrowserTab";
import { useSelector } from "react-redux";
import ContentReceiver from "../MenuLayout/ContentReceiverNewBrowserTab/ContentReceiver";

const ContextMenu = ({ handleOpenEligibility, handleOpenMasterWeek, handleClaimScreenOpen, scrollY, handleOpenCopay, contextMenuProvider, setContextMenuProvider, setAddModal, handleDeleteModal, findAppointmentByID }) => {

  let yPixels = contextMenuProvider?.type === 'dateWrapper' ? 250 - scrollY.current : 70;
  let xPixels = contextMenuProvider?.type === 'dateWrapper' ? 370 : 460;
  // console.log("yPixels", yPixels, contextMenuProvider?.type);
  let PatientIDR = useSelector(state => state.Open_Patient_Tab.find((pt) => pt.active === true));

  let patientID = PatientIDR?.data?.id;

  const [openTab, setOpenTab] = useState('');

  const contextMenuRef = useRef(null);
  const handleOpenNewBrowserTab = useHandleOpenNewBrowserTab();
  const handlePatientCopay = (data) => {
    handleOpenCopay(data?.PatientID, data?.PatientAppointmentID)
  }
  const handlePatientEligibility = (data) => {
    handleOpenEligibility(data?.PatientID);
  }

  const handlePatientDetail = (details) => {

    let data = {
      name: 'Patient',
      data: {
        id: details?.PatientID,
        name: details?.FirstName,
      }
    };
    handleOpenNewBrowserTab(data)

  }

  const handleAppointmentDetails = (data) => {
    findAppointmentByID(data.PatientAppointmentID)
  }

  const CreateProfessionalClaim = (data) => {
    console.log("CreateProfessionalClaim_data", data)
    let dataObj = {
      key: 2,
      name: "Claims",
      active: true,
      data: {
        name: "New Professional",
        id: -1,
        time: new Date(),
        visitType: "P",
        screenFrom: 'Scheduler',
        patientID: data?.PatientID,
        patientRecord: {
          data: {
            openFrom: 'Scheduler',
            id: data?.PatientID,
            name: data?.FirstName,
          },
        }

      },
    };
    setOpenTab(dataObj)
  }

  const CreateInstitutionalClaim = (data) => {
    console.log("CreateInstitutionalClaim_data", data)
    let dataObj = {
      key: 2,
      name: "Claims",
      active: true,
      data: {
        name: "New Institutional",
        id: -2,
        time: new Date(),
        visitType: "I",
        patientRecord: {
          data: {
            openFrom: 'Scheduler',
            id: data?.PatientID,
            name: data?.FirstName,
          },
        }
      },
    };
    setOpenTab(dataObj)
  }

  useEffect(() => {
    const handleDocumentClick = (e) => {
      if (
        contextMenuRef.current &&
        !contextMenuRef.current.contains(e.target)
      ) {

        setContextMenuProvider({ ...contextMenuProvider, show: false });
      }
    };

    document.addEventListener("click", handleDocumentClick);

    return () => {
      document.removeEventListener("click", handleDocumentClick);
    };
  }, []);

  return (
    <React.Fragment>

      {openTab ? <ContentReceiver data={openTab} setOpenTab={setOpenTab} /> : null}

      <div
        className="menu_button schduler_day"
        ref={contextMenuRef}
        style={{
          position: "absolute",
          top: `${contextMenuProvider.y - yPixels}px`,
          left: `${contextMenuProvider.x - xPixels}px`,
          zIndex: 1000
        }}
      >
        <ul className="menu_list">

          {contextMenuProvider?.event?.data ?
            <>
              <li
                className="cursor-pointer"
                onClick={() => handleAppointmentDetails(contextMenuProvider?.event?.data)}
              >
                <span className="text">View Detail</span>
              </li>
              <li
                className="cursor-pointer"
                onClick={() => handlePatientDetail(contextMenuProvider?.event?.data)}
              >
                <span className="text">View Patient</span>
              </li>
              <li
                className="cursor-pointer"
                onClick={() => handlePatientCopay(contextMenuProvider?.event?.data)}
              >
                <span className="text">Collect Copay</span>
              </li>
              <li
                className="cursor-pointer"
                onClick={() => handlePatientEligibility(contextMenuProvider?.event?.data)}
              >
                <span className="text">Perform Eligibility</span>
              </li>
              <li
                className="cursor-pointer"
                onClick={() => CreateProfessionalClaim(contextMenuProvider?.event?.data)}
              >
                <span className="text" >Create Professional Claim</span>
              </li>
              <li
                className="cursor-pointer"
                onClick={() => CreateInstitutionalClaim(contextMenuProvider?.event?.data)}
              >
                <span className="text" >Create Institutional Claim</span>
              </li>
            </> : contextMenuProvider?.type === "dateWrapper" ? (
              <>
                {/* {console.log("vobject",contextMenuProvider?.event?.date)} */}
                <li
                  className="cursor-pointer"

                  onClick={() => handleOpenMasterWeek({ PatientAppointmentID: 0, PatientID: patientID, AppointmentDate: contextMenuProvider?.event?.date })}
                >
                  <span className="text">Add New Schedule</span>
                </li>
                <li
                  className="cursor-pointer"
                  onClick={() => handleClaimScreenOpen()}
                >
                  <span className="text">Add New Claim</span>
                </li>

              </>
            ) : (
              <>
                <li
                  className="cursor-pointer"
                  onClick={() => handleAppointmentDetails({ PatientAppointmentID: 0 })}
                >
                  <span className="text">Add Appointment</span>
                </li>
                <li
                  className="cursor-pointer"
                  onClick={() => setAddModal(true)}
                >
                  <span className="text">Block Appointment</span>
                </li>
              </>
            )
          }

        </ul>
        {contextMenuProvider?.event?.data ? <div className="d-flex cursor-pointer align-items-center trash gap-2" onClick={handleDeleteModal}>
          <i className="icon-delete"></i>
          <p className="text" >Delete Appointment</p>
        </div> : ""}

      </div>
    </React.Fragment>
  );
};

export default ContextMenu;
